import React from 'react';
import { SettingsIcon, MailIcon } from 'lucide-react';
import { Accordion } from './Accordion';
import { OBJECTIONS, SUPPORT_EMAIL } from '../data/content';
export function Objections() {
  return <section className="px-5 py-10" data-id="element-107">
      <div className="mx-auto max-w-md" data-id="element-108">
        <h2 className="text-center font-anton text-2xl leading-tight text-white" data-id="element-109">
          Todavía tenés dudas? Te las resolvemos
        </h2>

        <div className="mt-6 space-y-3" data-id="element-110">
          {OBJECTIONS.map((o, i) => <Accordion key={i} emoji="❓" title={o.q} data-id="element-111">
              <p className="text-[14px] leading-snug text-neutral-300" data-id="element-112">{o.a}</p>
            </Accordion>)}
        </div>

        {/* Support */}
        <div className="mt-8 flex flex-col items-center gap-2 rounded-xl border border-white/10 bg-[#111]/90 p-5 text-center" data-id="element-113">
          <SettingsIcon className="h-8 w-8 text-[#F5C518]" data-id="element-114" />
          <p className="text-sm text-neutral-400" data-id="element-115">
            Soporte y ayuda con tu compra
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex items-center gap-2 font-oswald text-base font-600 text-white hover:text-[#F5C518]" data-id="element-116">
            <MailIcon className="h-4 w-4" data-id="element-117" />
            {SUPPORT_EMAIL}
          </a>
        </div>
      </div>
    </section>;
}